import toast from "react-hot-toast";
import { translateText } from "../i18n";
import { ALERT_MESSAGE, ALERT_MESSAGE_TYPE } from "./type";

export const toogleSuccessMessage = (payload) => {
  toast.success(translateText(payload));
};

export const toogleErrorMessage = (payload) => {
  toast.error(translateText(payload));
};

export const toogleMessage = (payload, type) => (dispatch) => {
  dispatch({ type: ALERT_MESSAGE, payload: payload });
  dispatch({ type: ALERT_MESSAGE_TYPE, payload: type });
};
